// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__pVgvf","notes":"Notes_notes__3WNb0","note":"Notes_note__38L19","markdown":"Notes_markdown__Lrz4-"};